import React from 'react';
import { useSite } from '../../context/SiteContext';
import CountUp from 'react-countup';

export const PromoBar = () => {
  const { settings } = useSite();

  if (!settings?.promo_bar_enabled) return null;

  return (
    <div 
      className="promo-bar text-white"
      style={{ background: `linear-gradient(90deg, ${settings.primary_color}, ${settings.primary_color}dd)` }}
    >
      <div className="mx-auto max-w-7xl px-4 py-3 flex items-center justify-center gap-2 text-center text-sm md:text-base font-semibold flex-wrap">
        <span>{settings.promo_bar_text}</span>
        <span style={{ color: settings.accent_color }} className="font-bold">
          Quantity in stock:
        </span>
        <span className="text-xl md:text-2xl font-black ml-1" data-testid="stock-count">
          <CountUp end={settings.stock_count} duration={2} />
        </span>
      </div>
    </div>
  );
};

export const NoticeBar = () => {
  const { settings } = useSite();

  if (!settings?.notice_bar_enabled) return null;

  return (
    <div className="mx-auto max-w-7xl px-4 pt-4">
      <div className="notice-bar rounded-2xl px-5 py-3 text-center font-semibold text-slate-800 text-sm md:text-base">
        {settings.notice_bar_text}
      </div>
    </div>
  );
};
